import { Button, Dialog, DialogTitle, Stack } from '@mui/material';
import useToDo from 'hooks/useToDo';
import { useSnackbar } from 'notistack';
import { FormattedMessage } from 'react-intl';

function DeleteTodoModal({ setOpenDeleteModal, todo, selectedDate }) {
  const { deleteToDo, isLoading } = useToDo(selectedDate);
  const { enqueueSnackbar } = useSnackbar();

  const handleDelete = async (todoId: string) => {
    try {
      await deleteToDo({ id: todoId });
      enqueueSnackbar('todo deleted successfully', { variant: 'success' });
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Dialog
      open
      onClose={() => {
        setOpenDeleteModal(false);
      }}
    >
      <DialogTitle>
        <FormattedMessage defaultMessage="Are you sure you want to delete this todo ? " />
      </DialogTitle>
      <Stack direction={'row'} spacing={2} m={2} justifyContent="flex-end">
        <Button
          variant="contained"
          color="error"
          onClick={() => {
            handleDelete(todo?._id);
            setOpenDeleteModal(false);
          }}
        >
          <FormattedMessage defaultMessage="Delete" />
        </Button>
        <Button
          variant="outlined"
          onClick={() => {
            setOpenDeleteModal(false);
          }}
          disabled={isLoading}
        >
          <FormattedMessage defaultMessage="Cancel" />
        </Button>
      </Stack>
    </Dialog>
  );
}

export default DeleteTodoModal;
